mutation UploadBanner($input: UploadBannerInput!) {
  file: uploadBanner(input: $input) {
    id
    url
  }
}
